import clone from 'lodash/clone';
import Bluebird from 'bluebird';
export var doesUserHasPermission = function (permission) {
    return new Bluebird(function (resolve) {
        SP.SOD.executeFunc('sp.js', 'SP.BasePermissions', function () {
            var permissions = new SP.BasePermissions();
            permissions.fromJson(clone(_spPageContextInfo.webPermMasks));
            resolve(permissions.has(permission));
        });
    });
};
export var ensureSod = function (fileName, typeName, beforeSod) {
    return new Bluebird(function (resolve) {
        var type = 'undefined';
        try {
            type = Function('', "return typeof window." + typeName)();
        }
        catch (error) { }
        if (type !== 'undefined') {
            resolve();
        }
        else {
            if (beforeSod) {
                beforeSod();
            }
            SP.SOD.executeFunc(fileName, typeName, function () {
                resolve();
            });
        }
    });
};
